import ShareContextMenu from './components/ShareContextMenu'
import AudioLanguageContextMenu from './components/AudioLanguageContextMenu'
import TourLanguageContextMenu from './components/TourLanguageContextMenu'
import VideoQualityContextMenu from './components/VideoQualityContextMenu'
import OverflowContextMenu from './containers/OverflowContextMenu'
import {
    SHARE_MENU,
    AUDIO_LANGUAGE_MENU,
    TOUR_LANGUAGE_MENU,
    VIDEO_QUALITY_MENU,
    OVERFLOW_MENU,
} from './contextMenuActions'

export default {
    menus: {
        [SHARE_MENU]: ShareContextMenu,
        [AUDIO_LANGUAGE_MENU]: AudioLanguageContextMenu,
        [TOUR_LANGUAGE_MENU]: TourLanguageContextMenu,
        [VIDEO_QUALITY_MENU]: VideoQualityContextMenu,
        [OVERFLOW_MENU]: OverflowContextMenu,
    },
}
